// ChangePasswordView.jsx
import { useState } from 'react';
import styled from 'styled-components';
import { Input } from '../../../components/ui';
import { changePassword } from '../../../api/services/customerService';
import { useSelector } from 'react-redux';

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Title = styled.h1`
  width: 100%;
  font-size: 24px;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const InputGroup = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const InputLabel = styled.label`
  font-size: 14px;
  color: #444;
`;

const InputContainer = styled.div`
  width: 100%;
  border: 1px solid #ccc;
  margin-bottom: 20px;
`;

const SubmitButton = styled.button`
  width: 80%;
  padding: 12px;
  background-color: ${(props) => props.theme.colors.primaryBlue};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 1rem;
  transition: background-color 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

const ChangePasswordView = () => {
  const userInfo = useSelector((state) => state.userInfo);

  const [passwords, setPasswords] = useState({
    old: '',
    new: '',
    confirm: '',
  });

  const handleSubmit = async () => {
    const result = await changePassword(
      userInfo.idCustomer,
      passwords.old,
      passwords.new,
    );
    if (result.is_success) {
      alert('Password changed Successfully');
    }
  };

  return (
    <FormContainer>
      <Title>Change Password</Title>

      <InputGroup>
        <InputLabel>Old password:</InputLabel>
        <InputContainer>
          <Input
            type='password'
            value={passwords.old}
            onChange={(value) => {
              setPasswords({ ...passwords, old: value });
            }}
          />
        </InputContainer>
      </InputGroup>

      <InputGroup>
        <InputLabel>New password:</InputLabel>
        <InputContainer>
          <Input
            type='password'
            value={passwords.new}
            onChange={(value) => {
              setPasswords({ ...passwords, new: value });
            }}
          />
        </InputContainer>
      </InputGroup>

      <InputGroup>
        <InputLabel>Confirm password:</InputLabel>
        <InputContainer>
          <Input
            type='password'
            value={passwords.confirm}
            onChange={(value) => {
              setPasswords({ ...passwords, confirm: value });
            }}
          />
        </InputContainer>
      </InputGroup>

      <SubmitButton
        onClick={() => {
          handleSubmit();
        }}
      >
        SUBMIT
      </SubmitButton>
    </FormContainer>
  );
};

export default ChangePasswordView;
